import { RESET_PDF_GEN_ACTIVITY, SET_CONFIGURATION_SETTINGS, SET_PDF_GEN_ACTIVITY } from '@state-management/constants';
import { IPDFComponentStatus } from '../reducers/configuration';

export interface SetConfigurationPayload {
  data: unknown[] | null;
}

export interface SetPdfGenPayload {
  data: IPDFComponentStatus;
  deviceHints?: { isMobile?: boolean; isTablet?: boolean };
}

export class SetConfigurationAction {
  readonly type = SET_CONFIGURATION_SETTINGS;
  constructor(public readonly payload?: SetConfigurationPayload) {}
}

export class SetPDFGenAction {
  readonly type = SET_PDF_GEN_ACTIVITY;
  constructor(public readonly payload?: SetPdfGenPayload) {}
}

export class ResetPDFGenAction {
  readonly type = RESET_PDF_GEN_ACTIVITY;
}
